import { Container } from "react-bootstrap"

const Footer = () => {
    return (
        <Container fluid className="bg-dark p-5 text-white text-center">

            <h3>We provide best products</h3>
            <p>All rights reserved - <b> Gulshan Kumar</b></p>

        </Container>
    )
}

export default Footer